// Meta Pixel + Google Analytics 4 — carregados apenas se os IDs estiverem configurados
// Configure REACT_APP_META_PIXEL_ID e REACT_APP_GA_MEASUREMENT_ID no frontend/.env

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initTracking() {
  if (initialized) return;
  initialized = true;

  if (PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", PIXEL_ID);
    /* eslint-enable */
  }

  if (GA_ID) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }
}

export function trackPageView(path) {
  if (window.fbq) window.fbq("track", "PageView");
  if (window.gtag && GA_ID) window.gtag("event", "page_view", { page_path: path });
}

export function trackViewContent(product) {
  const params = {
    content_ids: [product.id],
    content_name: product.name,
    content_type: "product",
    value: product.effective_price ?? product.price,
    currency: "BRL",
  };
  if (window.fbq) window.fbq("track", "ViewContent", params);
  if (window.gtag) window.gtag("event", "view_item", params);
}

export function trackAddToCart(product, qty = 1) {
  const params = {
    content_ids: [product.id],
    content_name: product.name,
    content_type: "product",
    value: (product.effective_price ?? product.price) * qty,
    currency: "BRL",
  };
  if (window.fbq) window.fbq("track", "AddToCart", params);
  if (window.gtag) window.gtag("event", "add_to_cart", params);
}

export function trackInitiateCheckout(total) {
  const params = { value: total, currency: "BRL" };
  if (window.fbq) window.fbq("track", "InitiateCheckout", params);
  if (window.gtag) window.gtag("event", "begin_checkout", params);
}

export function trackContact(total) {
  const params = { value: total, currency: "BRL" };
  if (window.fbq) window.fbq("track", "Contact", params);
  if (window.gtag) window.gtag("event", "generate_lead", params);
}
